import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=b8989b6e&scoped=true&"
import script from "./RangeSlider.vue?vue&type=script&lang=js&"
export * from "./RangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./RangeSlider.vue?vue&type=style&index=0&id=b8989b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8989b6e",
  null
  
)

export default component.exports